import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ViewAllPrintJobsHomeComponent } from './view-all-print-jobs/view-all-print-jobs-home.component';
import { ViewAllPrintJobsSearchComponent } from './view-all-print-jobs/view-all-print-jobs-search/view-all-print-jobs-search.component';
import { ViewMyPrintJobsHomeComponent } from './view-my-print-jobs/view-my-print-jobs-home.component';
import { ViewMyPrintJobsSearchComponent } from './view-my-print-jobs/view-my-print-jobs-search/view-my-print-jobs-search.component';
import { ReportsConfigurationHomeComponent } from './reports-configuration/reports-configuration-home/reports-configuration-home.component';
// tslint:disable-next-line:max-line-length
import { ReportsConfigurationSearchComponent } from './reports-configuration/reports-configuration-home/reports-configuration-search/reports-configuration-search.component';
import { ReportsConfigurationDetailsComponent } from './reports-configuration/reports-configuration-home/reports-configuration-details/reports-configuration-details.component';
import { MaintainReportHomeComponent } from './maintain-report/maintain-report-home/maintain-report-home.component';
import { MaintainReportSearchComponent } from './maintain-report/maintain-report-home/maintain-report-search/maintain-report-search.component';
import { MaintainReportDetailsComponent } from './maintain-report/maintain-report-home/maintain-report-details/maintain-report-details.component';
import { isScreenAccess } from '../../guards/is-screen-access';
import { AlwaysAuthChildrenGuard } from '../../guards/always-auth-children.guard';

@NgModule({
  imports: [
    RouterModule.forChild([
      { path: '', redirectTo: 'view-all-print-jobs', pathMatch: 'full' },
      { path: 'view-all-print-jobs', component: ViewAllPrintJobsHomeComponent,
        canActivate: [isScreenAccess],
        canActivateChild: [AlwaysAuthChildrenGuard],
        children: [
          { path: '', redirectTo: 'search', pathMatch: 'full' },
          { path: 'search', component: ViewAllPrintJobsSearchComponent },
        ]
      },
      { path: 'view-my-print-jobs', component: ViewMyPrintJobsHomeComponent,
        canActivate: [isScreenAccess],
        canActivateChild: [AlwaysAuthChildrenGuard],
        children: [
          { path: '', redirectTo: 'search', pathMatch: 'full' },
          { path: 'search', component: ViewMyPrintJobsSearchComponent },
        ]
      },
      {
        path: 'reports-config', component: ReportsConfigurationHomeComponent,
        canActivate: [isScreenAccess],
        canActivateChild: [AlwaysAuthChildrenGuard],
        children: [
          { path: '', redirectTo: 'search', pathMatch: 'full' },
          { path: 'search', component: ReportsConfigurationSearchComponent},
          { path: 'search/:searchId', component: ReportsConfigurationSearchComponent},
          { path: 'details', component: ReportsConfigurationDetailsComponent},
          { path: 'details/:docId', component: ReportsConfigurationDetailsComponent }
        ]
      },
      {
        path: 'maintain-report', component: MaintainReportHomeComponent,
        canActivate: [isScreenAccess],
        canActivateChild: [AlwaysAuthChildrenGuard],
        children: [
          { path: '', redirectTo: 'search', pathMatch: 'full' },
          { path: 'search', component: MaintainReportSearchComponent},
          { path: 'search/:searchId', component: MaintainReportSearchComponent},
          { path: 'details', component: MaintainReportDetailsComponent},
          { path: 'details/:docId', component: MaintainReportDetailsComponent }
        ]
      }
    ])
  ],
  exports: [RouterModule]
})
export class ReportsRoutingModule { }



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/features/reports/reports-routing.module.ts